import { createFileRoute } from '@tanstack/react-router'

import AdminBppPage from '@/components/pages/backoffice/_user/_bpp/containers/AdminBppPage'
export const Route = createFileRoute('/_backoffice/user/bpp/')({
  component: AdminBppPage
})
